import posthog from 'posthog-js'

const logger = posthog.logger

// main.tsx uses the documented PostHog host as a safe default when only the
// public project key is present, so event and log helpers must use the same
// readiness check.
export const isPostHogConfigured = Boolean(import.meta.env.VITE_POSTHOG_KEY)

export const posthogLogs = {
  loginSucceeded() {
    logger.info('user login succeeded', { flow: 'password' })
  },
  logoutSucceeded() {
    logger.info('user logout succeeded')
  },
  diagnosticRecordSaved() {
    logger.info('diagnostic record saved', { storage: 'indexeddb' })
  },
  persistentStoragePermissionResolved(granted: boolean) {
    logger.info('persistent storage permission resolved', { granted })
  },
}
